import { render, staticRenderFns } from "./echart-pies.vue?vue&type=template&id=2da84bc8&scoped=true&"
import script from "./echart-pies.vue?vue&type=script&lang=js&"
export * from "./echart-pies.vue?vue&type=script&lang=js&"
import style0 from "./echart-pies.vue?vue&type=style&index=0&id=2da84bc8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da84bc8",
  null
  
)

export default component.exports